import React, { Component } from 'react';
import { NavLink, Link } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import "./BackendHeader.css";

class BackendHeader extends Component {

  state = {
    website_name: "",
    website_logo: null,
    preview_logo: null,
  };

  API_BASE = axios.defaults.baseURL;
  PUBLIC_BASE = this.API_BASE.replace("/api", "");

  componentDidMount() {
    this.fetchFooterData();
  }

  fetchFooterData = async () => {
    try {
      const res = await axios.get("/theme_customizable");
      const d = res?.data?.data;
      if (d) {
        this.setState({
          website_name: d.website_name || "",
          preview_logo: d.website_logo ? `${this.PUBLIC_BASE}/${d.website_logo}` : null,
        });
      }
    } catch (error) {
      console.error("Footer fetch error:", error);
    }
  };

  handleDropdown = (e) => {
    e.preventDefault();
    const parent = e.currentTarget.closest(".pc-item");
    parent?.classList.toggle("pc-trigger");
  };

  // Robust Desktop Sidebar Hide / Collapse Toggle
  handleSidebarCollapse = (e) => {
    e.preventDefault();
    const body = document.body;
    // Toggles both custom and standard Able Pro template classes to ensure compatibility
    body.classList.toggle("sidebar-hide");
    body.classList.toggle("pc-sidebar-hide");
  };

  // Mobile Sidebar Toggle
  handleMobileCollapse = (e) => {
    e.preventDefault();
    const body = document.body;
    body.classList.toggle("mob-sidebar-active");
    body.classList.toggle("pc-mob-sidebar");
  };

  handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    localStorage.removeItem("auth_token");
    localStorage.removeItem("user");
    localStorage.removeItem("user_id");
    localStorage.removeItem("fullname");

    localStorage.removeItem("dashboard");
    localStorage.removeItem("bookings");
    localStorage.removeItem("posts");
    localStorage.removeItem("customers");
    localStorage.removeItem("coupons");
    localStorage.removeItem("admins");
    localStorage.removeItem("seo_pages");
    localStorage.removeItem("expenses");
    localStorage.removeItem("additional_page");
    localStorage.removeItem("landing_page");
    localStorage.removeItem("theme_customization");
    localStorage.removeItem("settings");

    localStorage.removeItem("user_role");
    window.location.href = "/admin/login";
  };

  render() {
    const { preview_logo } = this.state;

    return (
      <>
        <div className="loader-bg">
          <div className="loader-track">
            <div className="loader-fill" />
          </div>
        </div>

        <nav className="pc-sidebar">
          <div className="navbar-wrapper">
            <div className="m-header">
              <NavLink to="/" className="b-brand text-primary">
                {preview_logo && (
                  <img
                    src={preview_logo}
                    alt="Logo"
                    className="img-fluid logo-lg"
                    style={{ width: "160px", paddingTop: "8px" }}
                  />
                )}
              </NavLink>
            </div>

            <div className="navbar-content">
              <ul className="pc-navbar">
                {(localStorage.getItem("dashboard") === "1" ||
                  localStorage.getItem("user_role") === "merchant") && (
                    <li className="pc-item">
                      <NavLink to="/admin/dashboard" className="pc-link">
                        <span className="pc-micon">
                          <i className="ph ph-house-line" />
                        </span>
                        <span className="pc-mtext">Dashboard</span>
                      </NavLink>
                    </li>
                  )}

                {(localStorage.getItem("bookings") === "1" ||
                  localStorage.getItem("user_role") === "merchant") && (
                    <span className="pc-item pc-hasmenu">
                      <div className="pc-link" onClick={this.handleDropdown}>
                        <span className="pc-micon">
                          <i className="ph ph-shopping-cart" />
                        </span>
                        <span className="pc-mtext">Bookings</span>
                        <span className="pc-arrow">
                          <i className="ti ti-chevron-right" />
                        </span>
                      </div>
                      <ul className="pc-submenu">
                        <li className="pc-item">
                          <NavLink to="/admin/bookings" className="pc-link">
                            All Bookings
                          </NavLink>
                        </li>
                      </ul>
                    </span>
                )}

                {(localStorage.getItem("customers") === "1" ||
                  localStorage.getItem("user_role") === "merchant") && (
                    <li className="pc-item">
                      <NavLink to="/admin/customers" className="pc-link">
                        <span className="pc-micon">
                          <i className="ph ph-users-four" />
                        </span>
                        <span className="pc-mtext">Customers</span>
                      </NavLink>
                    </li>
                  )}

                {(localStorage.getItem("posts") === "1" ||
                  localStorage.getItem("user_role") === "merchant") && (
                    <span className="pc-item pc-hasmenu">
                      <div className="pc-link" onClick={this.handleDropdown}>
                        <span className="pc-micon">
                          <i className="ph ph-package" />
                        </span>
                        <span className="pc-mtext">Properties</span>
                        <span className="pc-arrow">
                          <i className="ti ti-chevron-right" />
                        </span>
                      </div>
                      <ul className="pc-submenu">
                        <li className="pc-item">
                          <NavLink to="/admin/posts" className="pc-link">
                            All Post
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/posts/reports" className="pc-link">
                            Reports
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/posts/categories" className="pc-link">
                            Categories
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/posts/tags" className="pc-link">
                            Tags
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/posts/facilities" className="pc-link">
                            Facilities
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/posts/comments" className="pc-link">
                            Reviews
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/posts/addresses" className="pc-link">
                            Addresses
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/posts/locations" className="pc-link">
                            Locations
                          </NavLink>
                        </li>
                      </ul>
                    </span>
                  )}

                  {(localStorage.getItem("posts") === "1" ||
                  localStorage.getItem("user_role") === "merchant") && (
                    <span className="pc-item pc-hasmenu">
                      <div className="pc-link" onClick={this.handleDropdown}>
                        <span className="pc-micon">
                          <i className="ph ph-package" />
                        </span>
                        <span className="pc-mtext">Payment</span>
                        <span className="pc-arrow">
                          <i className="ti ti-chevron-right" />
                        </span>
                      </div>
                      <ul className="pc-submenu">
                        <li className="pc-item">
                          <NavLink to="/admin/posts" className="pc-link">
                            Customer Payment 
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/posts/categories" className="pc-link">
                            Customer Refunds
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/posts/tags" className="pc-link">
                            Host Payouts
                          </NavLink>
                        </li>
                      </ul>
                    </span>
                  )}

                  {(localStorage.getItem("admins") === "1" ||
                  localStorage.getItem("user_role") === "merchant") && (
                    <span className="pc-item pc-hasmenu">
                      <div className="pc-link" onClick={this.handleDropdown}>
                        <span className="pc-micon">
                          <i className="ph ph-chart-line-up" />
                        </span>
                        <span className="pc-mtext">Investors</span>
                        <span className="pc-arrow">
                          <i className="ti ti-chevron-right" />
                        </span>
                      </div>
                      <ul className="pc-submenu">
                        <li className="pc-item">
                          <NavLink to="/admin/investors" className="pc-link">
                            Investors
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/investor-projects" className="pc-link">
                            Investor Projects
                          </NavLink>
                        </li>
                      </ul>
                    </span>
                  )}

                  {(localStorage.getItem("admins") === "1" ||
                  localStorage.getItem("user_role") === "merchant") && (
                    <span className="pc-item pc-hasmenu">
                      <div className="pc-link" onClick={this.handleDropdown}>
                        <span className="pc-micon">
                          <i className="ph ph-note-pencil" />
                        </span>
                        <span className="pc-mtext">CMS</span>
                        <span className="pc-arrow">
                          <i className="ti ti-chevron-right" />
                        </span>
                      </div>
                      <ul className="pc-submenu">
                        <li className="pc-item">
                          <NavLink to="/admin/blogs" className="pc-link">
                            Blogs
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/careers" className="pc-link">
                            Careers
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/faqs" className="pc-link">
                            FAQs
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/news" className="pc-link">
                            News
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/testimonials" className="pc-link">
                            Testimonials
                          </NavLink>
                        </li>
                        <li className="pc-item">
                          <NavLink to="/admin/notifications" className="pc-link">
                            Notifications
                          </NavLink>
                        </li>
                      </ul>
                    </span>
                  )}

                {(localStorage.getItem("additional_page") === "1" ||
                  localStorage.getItem("user_role") === "merchant") && (
                    <li className="pc-item">
                      <NavLink to="/admin/additional_pages" className="pc-link">
                        <span className="pc-micon">
                          <i className="ph ph-book-open-text" />
                        </span>
                        <span className="pc-mtext">Additional Pages</span>
                      </NavLink>
                    </li>
                  )}

                {(localStorage.getItem("settings") === "1" ||
                  localStorage.getItem("user_role") === "merchant") && (
                    <span className="pc-item pc-hasmenu">
                      <div className="pc-link" onClick={this.handleDropdown}>
                        <span className="pc-micon">
                          <i className="ph ph-gear-six" />
                        </span>
                        <span className="pc-mtext">Settings</span>
                        <span className="pc-arrow">
                          <i className="ti ti-chevron-right" />
                        </span>
                      </div>
                      <ul className="pc-submenu">
                        <span className="pc-item">
                          <NavLink to="/admin/admins/list" className="pc-link">
                            Admins
                          </NavLink>
                        </span>
                        <span className="pc-item">
                          <NavLink to="/admin/theme/customizable" className="pc-link">
                            Website Customizable
                          </NavLink>
                        </span>
                        <span className="pc-item">
                          <NavLink to="/admin/facebook_pixel" className="pc-link">
                            Facebook Pixel
                          </NavLink>
                        </span>
                        <span className="pc-item">
                          <NavLink to="/admin/google_site_setup" className="pc-link">
                            Google Site Setups
                          </NavLink>
                        </span>
                      </ul>
                    </span>
                  )}
              </ul>
            </div>
          </div>
        </nav>

        <header className="pc-header">
          <div className="header-wrapper">
            <div className="me-auto pc-mob-drp">
              <ul className="list-unstyled">
                <li className="pc-h-item pc-sidebar-collapse">
                  <Link to="#" className="pc-head-link ms-0" id="sidebar-hide" onClick={this.handleSidebarCollapse}>
                    <i className="ph ph-list" />
                  </Link>
                </li>
                <li className="pc-h-item pc-sidebar-popup">
                  <Link to="#" className="pc-head-link ms-0" id="mobile-collapse" onClick={this.handleMobileCollapse}>
                    <i className="ph ph-list" />
                  </Link>
                </li>
                <li className="dropdown pc-h-item">
                  <Link className="pc-head-link arrow-none m-0 trig-drp-search" to="/" target="_blank" role="button" aria-haspopup="false" aria-expanded="false">
                    <i className="ph ph-globe" />
                  </Link>
                </li>
              </ul>
            </div>
            <div className="ms-auto">
              <ul className="list-unstyled">
                <li className="dropdown pc-h-item">
                  <Link className="pc-head-link dropdown-toggle arrow-none me-0" data-bs-toggle="dropdown" to="#" role="button" aria-haspopup="false" aria-expanded="false">
                    <i className="ph ph-bell" />
                    <span className="badge bg-success pc-h-badge">5</span>
                  </Link>
                  <div className="dropdown-menu dropdown-notification dropdown-menu-end pc-h-dropdown">
                    <div className="dropdown-header d-flex align-items-center justify-content-between">
                      <h5 className="m-0">Notifications</h5>
                      <Link to="#!" className="btn btn-link btn-sm">Mark all read</Link>
                    </div>
                    <div className="dropdown-body text-wrap header-notification-scroll position-relative" style={{ maxHeight: 'calc(100vh - 215px)' }}>
                      <p className="text-span">Today</p>
                      <div className="card bg-transparent mb-2 border-0">
                        <div className="card-body p-3 rounded" style={{ background: 'rgba(var(--bs-light-rgb), 0.3)', transition: 'all 0.2s ease' }}>
                          <div className="d-flex">
                            <div className="flex-shrink-0">
                              <div className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
                                <i className="ph ph-credit-card text-success" style={{ fontSize: 16 }} />
                              </div>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <span className="float-end text-sm text-muted">2 min ago</span>
                              <h5 className="text-body mb-2">Payment Received</h5>
                              <p className="mb-0">$2,499.00 payment received for Pro Plan subscription from Acme Corp</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card bg-transparent mb-2 border-0">
                        <div className="card-body p-3 rounded" style={{ background: 'rgba(var(--bs-light-rgb), 0.3)', transition: 'all 0.2s ease' }}>
                          <div className="d-flex">
                            <div className="flex-shrink-0">
                              <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
                                <i className="ph ph-users text-primary" style={{ fontSize: 16 }} />
                              </div>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <span className="float-end text-sm text-muted">1 hour ago</span>
                              <h5 className="text-body mb-2">New Team Member</h5>
                              <p className="mb-0">Sarah Johnson joined your workspace and was assigned to the Marketing team</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card bg-transparent mb-2 border-0">
                        <div className="card-body p-3 rounded" style={{ background: 'rgba(var(--bs-light-rgb), 0.3)', transition: 'all 0.2s ease' }}>
                          <div className="d-flex">
                            <div className="flex-shrink-0">
                              <div className="bg-warning bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
                                <i className="ph ph-chart-line text-warning" style={{ fontSize: 16 }} />
                              </div>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <span className="float-end text-sm text-muted">3 hours ago</span>
                              <h5 className="text-body mb-2">Monthly Report Ready</h5>
                              <p className="mb-0">Your January analytics report is ready. Revenue up 24% vs last month</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p className="text-span">Yesterday</p>
                      <div className="card bg-transparent mb-2 border-0">
                        <div className="card-body p-3 rounded" style={{ background: 'rgba(var(--bs-light-rgb), 0.3)', transition: 'all 0.2s ease' }}>
                          <div className="d-flex">
                            <div className="flex-shrink-0">
                              <div className="bg-danger bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
                                <i className="ph ph-shield-check text-danger" style={{ fontSize: 16 }} />
                              </div>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <span className="float-end text-sm text-muted">18 hours ago</span>
                              <h5 className="text-body mb-2">Security Alert</h5>
                              <p className="mb-2">New login detected. If this wasn't you, please secure your account</p>
                              <button className="btn btn-sm btn-outline-secondary me-2">Ignore</button>
                              <button className="btn btn-sm btn-danger">Secure Account</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-center py-2">
                      <Link to="#!" className="link-danger">Clear all Notifications</Link>
                    </div>
                  </div>
                </li>
                <li className="dropdown pc-h-item header-user-profile">
                  <Link className="pc-head-link dropdown-toggle arrow-none me-0" data-bs-toggle="dropdown" to="#" role="button" aria-haspopup="false" data-bs-auto-close="outside" aria-expanded="false">
                    <i className="ph ph-user-circle" />
                  </Link>
                  <div className="dropdown-menu dropdown-menu-end pc-h-dropdown">
                    <div className="dropdown-header">
                      <h6 className="mb-0">Hello, {localStorage.getItem("fullname")}</h6>
                    </div>
                    <div className="dropdown-divider" />
                    <Link to="#" onClick={this.handleLogout} className="dropdown-item text-danger">
                      <i className="ph ph-sign-out" /><span>Sign Out</span>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </header>
      </>
    );
  }
}

export default BackendHeader;